import { getParents } from '@/lib/event'
import { Event } from '@nostr/tools/wasm'
import { atom, getDefaultStore, useAtomValue } from 'jotai'
import { atomFamily } from 'jotai-family'

export const repliesMapAtom = atom<Map<string, Event[]>>(new Map())

// per-parent replies atom; reactive to changes in the corresponding slot of
// repliesMapAtom (we re-derive the slice each read so consumers re-render on
// every addReplies that touches this parent).
export const repliesForParentAtom = atomFamily((parentKey: string) =>
  atom<Event[]>((get) => get(repliesMapAtom).get(parentKey) ?? [])
)

const store = getDefaultStore()

export function addReplies(replies: Event[]) {
  const curr = store.get(repliesMapAtom)
  let touched = false
  for (const reply of replies) {
    for (const ptr of getParents(reply)) {
      const parent = ptr
        ? 'id' in ptr
          ? ptr.id
          : 'identifier' in ptr
            ? `${ptr.kind}:${ptr.pubkey}:${ptr.identifier}`
            : null
        : reply.tags.find((t) => t[0] === 'q')?.[1]
      if (!parent) continue

      const prev = curr.get(parent) || []
      if (!prev.find((evt) => evt.id === reply.id)) {
        curr.set(parent, [...prev, reply])
        touched = true
      }
    }
  }
  if (touched) {
    store.set(repliesMapAtom, new Map(curr))
  }
}

export function resetReplies() {
  store.set(repliesMapAtom, new Map())
}

// hook helpers
export function useRepliesMap() {
  return useAtomValue(repliesMapAtom)
}

export function useRepliesForParent(parentKey: string) {
  return useAtomValue(repliesForParentAtom(parentKey))
}
